import { Component, Input } from '@angular/core';
import { AcademyLesson } from '../../academy/academy-catalog';
import { LessonStatus } from '../../academy/academy.service';

/**
 * Eine Lektion als Zeile (Themenseite, Suchergebnis, Seitenleiste der
 * Lektion): Status-Symbol, Titel, Dauer, Markierungen „Portalhinweis“ und
 * „Neu“. Die ganze Zeile ist der Link. Gedacht für `nb-list-item` — Trennlinie
 * und eingedrückte Auswahl kommen global aus dem CI.
 */
@Component({
  selector: 'app-academy-lesson-item',
  templateUrl: './academy-lesson-item.component.html',
  styleUrls: ['./academy-lesson-item.component.scss'],
})
export class AcademyLessonItemComponent {
  @Input({ required: true }) lesson!: AcademyLesson;
  @Input({ required: true }) title = '';
  @Input() status: LessonStatus = 'not_started';
  /** Zusatzzeile unter dem Titel (z. B. Thema im Suchergebnis). */
  @Input() subtitle = '';
  @Input() isNew = false;
  /** Laufende Nummer im Thema. */
  @Input() index?: number;
  /** Diese Lektion ist gerade geöffnet. */
  @Input() current = false;
  /** Ohne die Chips „Neu“ / „Portalhinweis“ (Seitenleiste, Themenseite). */
  @Input() compact = false;
  /** Zusammenfassung unter dem Titel — gehört mit zur klickbaren Zeile. */
  @Input() summary = '';
  /** Status rechts als Text-Chip („Abgeschlossen“ / „Begonnen“) — Themenseite. */
  @Input() showStatus = false;

  get icon(): string {
    return {
      completed: 'checkmark-circle-2',
      started: 'play-circle-outline',
      not_started: 'radio-button-off-outline',
    }[this.status];
  }
}
